var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic-file-upload-undo" }, [
    _vm._v("\n  " + _vm._s(_vm.$t("fileUpload.fileDeleted")) + "\n  "),
    _c(
      "button",
      {
        staticClass: "btn-text btn-text--primary",
        attrs: { type: "button" },
        on: {
          click: function ($event) {
            return _vm.$emit("recover")
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.$t("fileUpload.undo")) + "?\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }